import { AfterViewInit, ChangeDetectorRef, Component, effect, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, OnDestroy, input, computed, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ItemBasicDetailComponent } from './item-basic-detail/item-basic-detail.component';
import { IconsComponent } from '@sml/icons';
import { CommunityService, CommunitySignalService, FilesModel, IBuildItems, ICampaignItem, ICommunityPlaque, ISelectedPlaque, ITEM_STATUS_TYPE, ItemListingTypeEnum, ItemListingType, noWhitespaceValidator, ParticipationMethodEnum, SlideUpDownAnimation, Step, ITEM_TYPE_ENUM, POST_ITEM_TYPE, CampaignSignalService, ICampaignDetailModel, CampaignService, CampaignTypeEnumm, timePatternValidator, itemDatePatternValidator, AppFormService, IFormListingDto, TimeZoneEnum, IFormOverviewModel, ParticipantFormTypeEnum, ItemService, VolunteerShiftDto, IVolunteerShifts, IVolunteerShift, ItemModel, DateLevelEnum, IItemCreateDto, CampaignAccessLevelEnum, TooltipDirective } from '@sml/utility';
import { ToastrService } from '@sml/toastr';
import { SpinnerService } from '@sml/spinner';
import { ItemLocationComponent } from './item-location/item-location.component';
import { ButtonsModule } from '@sml/buttons';
import { ItemPricingComponent } from './item-pricing/item-pricing.component';
import { ItemUploadComponent } from './item-upload/item-upload.component';
import { ItemDonationComponent } from './item-donation/item-donation.component';
import { BUILD_ITEMS, Notification_STRINGS } from './build-items.constant';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ItemDatesComponent } from './item-dates/item-dates.component';
import { ItemParticipationComponent } from './item-participation/item-participation.component';


function priceRangeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const minPrice = control.get('customMinPrice')?.value;
    const maxPrice = control.get('customMaxPrice')?.value;
    if ((minPrice !== undefined && minPrice!==null ) && (maxPrice !== undefined && maxPrice!==null)) {
      if (maxPrice <= minPrice) {
        return { invalidPriceRange: true };  // Returns an error if maxPrice is less than or equal to minPrice
      }
    }
    return null;  // No error if the maxPrice is greater than minPrice
  };
}
import {TimezoneUtilService} from '@sml/utility';
import { ItemVisiblityComponent } from "./item-visiblity/item-visiblity.component";
import { TextEditorComponent } from '@sml/text-editor';

@Component({
  selector: 'sml-build-items',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IconsComponent,
    ButtonsModule,
    ItemBasicDetailComponent,
    ItemLocationComponent,
    ItemPricingComponent,
    ItemUploadComponent,
    ItemDonationComponent,
    ItemDatesComponent,
    ItemParticipationComponent,
    ItemVisiblityComponent,
    TextEditorComponent,
    TooltipDirective
],
  templateUrl: './build-items.component.html',
  styleUrl: './build-items.component.scss',
  animations: [SlideUpDownAnimation],
})
export class BuildItemsComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
  @Input() data: ICampaignItem | undefined;
  @Input() originalDescription: string = '';
  @Input() formOverviewModel!: IFormOverviewModel;
  @Input() listingTypeId?: ItemListingType = ItemListingTypeEnum.Single;
  @Input() isAddItemPage = false;
  @Input() isSaveClick = false;
  @Input() isFromCommunityStories = false;
  @Input() isEditItem = false;
  @Input() isStatusIdDonated = false;
  @Input() isArchive=false;
  @Input() preSelectedPlaque: ISelectedPlaque[] = [];
  @Input() isArchived=false;
  @Output() emitFormValue = new EventEmitter<IBuildItems>();
  @Output() emitFileStatus = new EventEmitter<boolean>();
  @Output() closeDrawerEvent = new EventEmitter<void>();
  @Output() emitFormValidity = new EventEmitter<{
    step: Step;
    isValid: boolean;
  }>();
  @Output() emitSaveClick = new EventEmitter<boolean>();
  @Output() isFormValid = new EventEmitter<boolean>(false);
  @Output() emitAvailableSteps = new EventEmitter<Step[]>();
  @Output() isShiftListAvailable = new EventEmitter<boolean>()
  availableSteps = [
    Step.BASIC_INFORMATION,
    Step.DATES,
    Step.DETAILS,
    Step.PARTICIPATION,
    Step.PRICING,
    Step.LOCATION,
    Step.UPLOADS,
    Step.DONATION,
  ];
  availableStepsLocal: Step[] = [];
  isDonationSelected = false;
  isLaptopView = false;
  uploadedMedia!: FilesModel;
  itemsStrings = BUILD_ITEMS;
  isCreateUrl = false;
  @Output() startDateTime = new EventEmitter<string | null>();
  @Output() endDateTime = new EventEmitter<string | null>();
  @Output() isDonationItemSelected = new EventEmitter<boolean | false>();
  @Input() addSingleDonatedItem=false
  isStartDate!: Date | null;
  isEndDate!: Date | null;
  startDateInTz!: string | null;
  endDateInTz!: string | null;
  removeErrorOnShift=false;
  public form!: FormGroup;
  public isItemDetailVisible = true;
  public isItemDateVisible = true;
  public isItemLocationVisible = true;
  public isItemPriceVisible = true;
  public isItemUploadVisible = true;
  public isDonationVisible = true;
  public isParticipationVisible = true;
  public communityPlaquesData: ICommunityPlaque = {};
  private donatedQuantity = 0;
  private readonly ngUnSubscribe$ = new Subject<void>();
  itemListingTypeEnum = ItemListingTypeEnum;
  showDate = false;
  isTypeVoulunteer = false;
  typeCampaign = input<number>(0);
  campaignType!: number;
  campaignStatus = CampaignTypeEnumm;
  campaignAccessType = CampaignAccessLevelEnum;
  startTimePatch = '';
  endTimePatch = '';
  startDatePatch = '';
  endDatePatch = '';
  hasStartTime = false;
  showRegistrationDate=false;
  formMasterTemplateId: number | null = null;
  formMasterId: number | null = null;
 @Input() isDonated = false;
 startAPM: string = 'AM';
 endAPM: string = 'AM';
 startAPMPatch!:string;
 isNewItem:boolean=true;
 endAPMPatch!:string;
 notificationForm!: FormGroup;
 @Input() customForms: { label: string; value: number }[] = [];
 @Input() formListingDict: { [key: number]: { isTemplateForm: boolean; id: number } } = {};
 @Output() showDateStepper = new EventEmitter<boolean>();
 @Output() showLocationStepper = new EventEmitter<boolean>();
 @Output() showPriceStepper = new EventEmitter<boolean>();
 @Output() showDetailsStepper = new EventEmitter<boolean>();
 @Output() removeErrorShift = new EventEmitter<boolean>();
 @Input() showShiftsError=false
 @Input() drawerSize=false
 showTimeZone=false;
 @Input() disableShiftOptions: boolean | null  = null;
 isCustomPrice=false;
 communityId=0;
  // Volunteer shift properties
  private volunteerShiftsData: IVolunteerShifts[] = [];
  private isCloseItem = false;
  private isVolunteerCampaign = false;
  @Input() isVolunteerEvent = false;
  @Input() saveDirectly = false;
  @Input() campaignId?: number;
  private isInteractiveTourType=false;
  showCustomizeEmailSection = false;
  notificationString = Notification_STRINGS;
  isRegistrationItem=false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly communitySignalService: CommunitySignalService,
    private readonly communityService: CommunityService,
    private readonly cdr: ChangeDetectorRef,
    private readonly router: Router,
    private readonly campaignService: CampaignService,
    private readonly campaignSignalService : CampaignSignalService,
    private timezoneUtil: TimezoneUtilService,
    private readonly itemService: ItemService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly toastrService: ToastrService,
    private readonly spinnerService: SpinnerService
  ) {
    effect(() => {
      const community = this.communitySignalService.getCommunity();
      if (community?.id) {
        this.communityId=community?.id
        this.getCommunitPlaques(community.id);
      }
    });
    this.inItForm();
    const currentUrl = this.router.url;
    this.isCreateUrl = currentUrl.includes('/create');

  }

  // _getCampaignEffect= effect(() => {
  //   if(this.campaignId()){
  //     this.getCampaignDetail();
  //   }
  // });
  
 

  ngOnChanges(changes: SimpleChanges): void {
    // Set Interactive Tour logic early to ensure correct validation
    if(this.isInteractiveTourType || this.typeCampaign()===CampaignTypeEnumm['Interactive Tour']){
      this.isDonated=true;
      this.isDonationSelected=true;
      this.listingTypeId=ItemListingTypeEnum.Single;
    }
    
    if (changes['data'] || changes['customForms'] || changes['formListingDict']) {
      this.patchForm();
    }
 
    if(changes['listingTypeId']) {
      this.listingTypeId = changes['listingTypeId'].currentValue;
    }
    if (changes['isFromCommunityStories']?.currentValue) {
      this.form
        .get('donation')
        ?.get('qrPlaque')
        ?.setValidators([Validators.required]);
      this.form
        .get('itemDetails')
        ?.get('statusId')
        ?.setValue(ITEM_STATUS_TYPE.Donated);
      this.clearAllValidators(this.itemPriceForm);
      this.isDonationSelected = true;
      this.listingTypeId = ItemListingTypeEnum.Single;
      this.form?.updateValueAndValidity();
      this.saveDirectly = true;
    }
    if (this.isSaveClick) {
      this.handleSubmit();
    }
    this.checkFormStatus();

    if (changes['isDonated']) {
      this.isDonated = changes['isDonated'].currentValue;
    }
    if(changes['showShiftsError']){
      this.showShiftsError=changes['showShiftsError'].currentValue;
    }
    if(changes['isStatusIdDonated']){
      if(this.isStatusIdDonated){
        this.itemDetailForm.get('statusId')?.setValue(ITEM_STATUS_TYPE.Donated);
        this.isDonated=true;
        this.isDonationSelected=true;
        // this.listingTypeId=ItemListingTypeEnum.Single;
        this.itemParticipationForm.get('formType')?.clearValidators();
        this.itemParticipationForm.get('formType')?.updateValueAndValidity();
        this.itemPriceForm.get('price')?.clearValidators();
        this.itemPriceForm.get('price')?.updateValueAndValidity();
        this.form?.updateValueAndValidity();
      }
      else{
        this.itemDetailForm.get('statusId')?.setValue(ITEM_STATUS_TYPE.Available)
        this.form?.updateValueAndValidity();
      }
    }
    if(changes['addSingleDonatedItem']){
      if(changes['addSingleDonatedItem'].currentValue===true){
        this.listingTypeId=ItemListingTypeEnum.Single
      }
    }
   
    this.applyValidators();
    this.cdr.detectChanges()
  }

  ngOnInit(): void {
    if(this.typeCampaign()){
      this.isTypeVoulunteer = this.typeCampaign() === CampaignTypeEnumm['Volunteer Activity']
    }
    if (this.isFromCommunityStories) {
      this.saveDirectly = true;
    }
    this.updateViewMode(window?.innerWidth);
    this.emitAvailableSteps.emit(
      this.availableSteps.filter((step) => step !== Step.DONATION)
    );
    if(this.typeCampaign()){

      this.isTypeVoulunteer = this.typeCampaign() === CampaignTypeEnumm['Volunteer Activity']
      this.setVolunteerCampaignType(this.isTypeVoulunteer);
    }
    const routeCampaignId = this.activatedRoute.snapshot.queryParams['campaignId'];
    if (routeCampaignId && !this.campaignId) {
      this.campaignId = +routeCampaignId;
      this.getCampaignDetail();
    }
    this.itemDetailForm
      .get('statusId')
      ?.valueChanges.subscribe((value: number) => {
        this.setItemFormStatusFields(value);
        if (value === ITEM_STATUS_TYPE.Available) {
          this.isDonated = false;
          if (this.isTypeVoulunteer) {
            this.showDateStepper.emit(true);
            this.showDetailsStepper.emit(true);
          }
          this.isDonationItemSelected.emit(true);

        } else {
          this.isDonated = true;
          if (this.isTypeVoulunteer) {
            this.showDateStepper.emit(false);
            this.showDetailsStepper.emit(false);
          }
          this.isDonationItemSelected.emit(false);
          this.itemParticipationForm.get('formType')?.clearValidators();
          this.itemParticipationForm.get('formType')?.updateValueAndValidity();
          this.itemPriceForm.get('price')?.clearValidators();
          this.itemPriceForm.get('price')?.updateValueAndValidity();

        }
        if (value === ITEM_STATUS_TYPE.Donated && this.isTypeVoulunteer) {
          this.showLocationStepper.emit(false);
        } else {
          this.showLocationStepper.emit(true);
        }
      });
      if(this.isFromCommunityStories){
        this.itemParticipationForm.get('formType')?.clearValidators();
        this.itemParticipationForm.get('formType')?.updateValueAndValidity()
      }
      if(this.isTypeVoulunteer){
        this.itemDatesForm.get('eventType')?.setValue(DateLevelEnum['Single Day Event']);
        this.itemDatesForm.get('eventType')?.updateValueAndValidity();
      }
  }

  getCampaignDetail() {
    if (this.campaignId) {
      this.campaignService
        .getCampaignById(this.campaignId)
        .pipe(takeUntil(this.ngUnSubscribe$))
        .subscribe((res) => {
          if (res) {
            this.formOverviewModel = {
              schema: res.standardFormSchema,
              title:res.standardFormTitle,
              description:res.standardFormDescription,
            }
            this.campaignType = res.type;
            if(this.campaignType===CampaignTypeEnumm['Volunteer Activity'] && this.itemDatesForm.get('eventType')?.value===null){
              this.itemDatesForm.get('eventType')?.setValue(DateLevelEnum['Single Day Event']);
              this.itemDatesForm.get('eventType')?.updateValueAndValidity();
            }
            this.applyValidators()
            this.cdr.detectChanges()
            if (
              (this.isTypeVoulunteer = res.typeName === 'Volunteer Activity')
            ) {
              this.setVolunteerCampaignType(true);
              this.showDate = true;
              this.showDateStepper.emit(true);
              this.showPriceStepper.emit(false);
            }
            else if( res.type === this.campaignStatus.Registration){
              this.showRegistrationDate = true;
              this.isRegistrationItem=true;
            }
            else {
              this.showDate = false;
              this.showDateStepper.emit(false);
              this.showPriceStepper.emit(true);
            }
            if (this.isTypeVoulunteer && this.isDonated) {
              this.showLocationStepper.emit(false);
            } else {
              this.showLocationStepper.emit(true);
            }
          if(this.isDonated){
            this.isDonationItemSelected.emit(false)
          }
          else{
            this.isDonationItemSelected.emit(true)

          }
          if(res.type === this.campaignStatus['Interactive Tour']){
            this.isInteractiveTourType=true;
          }
          if(this.isTypeVoulunteer && this.listingTypeId === this.itemListingTypeEnum.Multiple && !this.isDonated)
            this.showDetailsStepper.emit(true);
          }
          else{
            this.showDetailsStepper.emit(false);
          }
        
         
        });
    }
  }
  timeZoneMandatory(val:boolean){
    this.showTimeZone=val;
    if(val){
      this.itemDatesForm.get('timeZone')?.setValidators([Validators.required])
      this.itemDatesForm.get('timeZone')?.updateValueAndValidity();
    }
    else if(!val && !this.itemDatesForm.get('eventType')?.value){
      this.itemDatesForm.get('timeZone')?.clearValidators();
      this.itemDatesForm.get('timeZone')?.updateValueAndValidity();

    }
  }
  switchPriceRange(value:boolean){
    this.isCustomPrice=value
    if (value) {
      this.listingTypeId = ItemListingTypeEnum.Custom;
    } else {
      this.listingTypeId = ItemListingTypeEnum.Multiple;
    }
    
    this.applyValidators()
  }
  applyValidators() {
    const itemId =  this.listingTypeId 
    const campaignType =  this.campaignType ? this.campaignType : this.typeCampaign()
    if(campaignType && itemId){
      if(this.isDonated){
        this.clearAllPriceValidators();
        this.updateAllValuesAndValidity(this.itemPriceForm);
        this.cdr.detectChanges()
        return;  
      }
      if (itemId=== this.itemListingTypeEnum.Single && campaignType === CampaignTypeEnumm['Volunteer Activity']) {
        this.updateAllValuesAndValidity(this.itemPriceForm);
        this.clearAllPriceValidators();
        this.cdr.detectChanges()
        return;  
      }
      if (itemId === this.itemListingTypeEnum.Multiple && campaignType === CampaignTypeEnumm['Volunteer Activity']) {
        this.handleVolunteerActivityValidators();
        this.cdr.detectChanges()
        return;  
      }    
    
      if (!this.isCustomPrice && !this.isDonated) {
        this.setMultipleValidators();
        this.cdr.detectChanges()
      } else if (this.isCustomPrice && !this.isDonated) {
        this.setCustomValidators();
        this.cdr.detectChanges()

      } else {
        this.clearQuantityValidators();
        this.cdr.detectChanges()

      }
    
      this.itemPriceForm.get('remainingQuantity')?.updateValueAndValidity();
      this.itemPriceForm.get('quantity')?.updateValueAndValidity();
    
      if (this.listingTypeId === ItemListingTypeEnum.Single || this.listingTypeId === ItemListingTypeEnum.Multiple) {
        this.itemPriceForm.get('onlinePayment')?.setValidators([Validators.required]);
        this.itemPriceForm.get('onlinePayment')?.updateValueAndValidity();
      }
      this.cdr.detectChanges()
  
    }
   
  }

  clearAllPriceValidators() {
    const group = this.itemDetailForm
    Object.keys(this.itemPriceForm.controls).forEach((key) => {
      const control = this.itemPriceForm.get(key);
      control?.clearValidators();
      control?.updateValueAndValidity();
    });
    group.clearValidators();
  this.itemPriceForm.updateValueAndValidity();
  this.itemDetailForm.updateValueAndValidity();
  }
  handleVolunteerActivityValidators() {
    this.clearAllPriceValidators();
    if (this.isEditItem) {
      this.itemPriceForm.get('remainingQuantity')?.setValidators([Validators.required, Validators.min(1)]);
      this.updateAllValuesAndValidity(this.itemPriceForm);
      this.cdr.detectChanges()
    } 
    else {

      this.itemPriceForm.get('quantity')?.setValidators([Validators.required, Validators.min(1)]); 
      this.updateAllValuesAndValidity(this.itemPriceForm);
      this.cdr.detectChanges();

    }
    this.itemPriceForm.get('hasVolunteerShifts')?.setValidators([Validators.required]);
    this.updateAllValuesAndValidity(this.itemPriceForm);

    const hasShift = this.itemPriceForm.get('hasVolunteerShifts')?.value
    if(hasShift){
      this.itemPriceForm.get('remainingQuantity')?.clearValidators();
      this.itemDatesForm.get('timeZone')?.setValidators([Validators.required]);
      this.updateAllValuesAndValidity(this.itemDatesForm);

    }

    this.cdr.detectChanges()

  }
  setMultipleValidators() {
    this.clearAllPriceValidators();
    this.itemPriceForm.get('price')?.setValidators([Validators.required, Validators.min(1)]);
    this.itemPriceForm.get('price')?.updateValueAndValidity();
  
    if (this.isEditItem) {
      this.itemPriceForm.get('remainingQuantity')?.setValidators([Validators.required, Validators.min(1)]);
    } else {
      this.itemPriceForm.get('quantity')?.setValidators([Validators.required, Validators.min(1)]);
    }
  }
  
  setCustomValidators() {
   
    this.clearAllPriceValidators();
  
    this.itemPriceForm.get('customMinPrice')?.setValidators([Validators.required, Validators.min(1)]);
    this.itemPriceForm.get('customMaxPrice')?.setValidators([Validators.required, Validators.min(1)]);
    this.setDynamicValidators(); 
  
    this.clearQuantityValidators();
  }
  
  clearQuantityValidators() {
    this.itemPriceForm.controls['quantity'].clearValidators();
    this.itemPriceForm.controls['remainingQuantity'].clearValidators();
  }

  setDynamicValidators() {
    this.itemPriceForm.setValidators(priceRangeValidator()); 
    this.itemPriceForm.updateValueAndValidity();
  }

  ngAfterViewInit(): void {
    this.patchForm();
  }
  showDateAccordion(value: boolean) {
    this.showDate = value;
  }

  EndAPM(val: string) {
   
      this.endAPM = val;
    
  }
  StartAPM(val: string) {
    
      this.startAPM = val;
    
  }

  get itemIcon() {
    if (this.data?.itemListingType === ItemListingTypeEnum.Multiple) {
      return 'multiple-quantity-o';
    }
    return 'single-quantity-o';
  }

  parseUtcIsoToLocalDateTime(
    isoUtcString: string,
    dateType: string,
    isVolunteerShiftTimeParsing:boolean=false
  ): { date: string; time: string; amPm: string } {
    const utcDate = new Date(isoUtcString);
    const pad = (n: number): string => n.toString().padStart(2, '0');

    const day = pad(utcDate.getDate());
    const month = pad(utcDate.getMonth() + 1);
    const year = utcDate.getFullYear();

    const hours24 = utcDate.getHours();
    const minutes = pad(utcDate.getMinutes());

    let hours12 = hours24 % 12;
    hours12 = hours12 === 0 ? 12 : hours12;
    const amPm = hours24 >= 12 ? 'PM' : 'AM';

    const time = `${pad(hours12)}${minutes}`;

    // Only set global variables for main event times, not for shifts
    if(!isVolunteerShiftTimeParsing){
    if (dateType === 'start') {
      this.startAPMPatch = amPm;
    } else if (dateType === 'end') {
      this.endAPMPatch = amPm;
    }
  }

    return {
      date: `${month}/${day}/${year}`,
      time,
      amPm
    };
  }

  public patchForm() {
    if (this.data) {

    this.isNewItem = this.data.isNew ?? false;
    const eventTimeZone = this.data.itemEventModel?.itemEventTimeZone;
    if (this.data.itemEventModel?.itemEventStartTime) {
      let eventStartTime = this.data.itemEventModel?.itemEventStartTime;
     const isUtcTime = typeof eventStartTime === 'string' && eventStartTime.endsWith('Z');
     if (isUtcTime) {
      eventStartTime = this.timezoneUtil.convertFromUTCToSelectedTimezone(
      eventStartTime,
      this.data.itemEventModel?.itemDateEventType == 148 && this.data.itemEventModel?.hasEventTimeEntered
      ? (eventTimeZone ?? TimeZoneEnum.EST) : TimeZoneEnum.EST
    )
   
  }else{
    if(this.data.itemEventModel?.itemDateEventType == 148 && this.data.itemEventModel?.hasEventTimeEntered){
        eventStartTime = this.timezoneUtil.convertFromESTToSelectedTimezone(
      eventStartTime,
      eventTimeZone ?? TimeZoneEnum.EST)}
  }

  const eventStartDate = this.parseUtcIsoToLocalDateTime(eventStartTime, 'start');
  const date = eventStartDate.date; // yyyy-mm-dd
  const time = eventStartDate.time; // HH:mm

  if (this.data.itemEventModel?.hasEventTimeEntered) {
    this.startTimePatch = time;
  }
  this.startDatePatch = date;
//  this.cdr.detectChanges();
}

  if (this.data.itemEventModel?.itemEventEndTime) {
  let eventEndTime = this.data.itemEventModel.itemEventEndTime;
  const isUtcTime =
    typeof eventEndTime === 'string' && eventEndTime.endsWith('Z');

    if (isUtcTime) {
      eventEndTime = this.timezoneUtil.convertFromUTCToSelectedTimezone(
      eventEndTime,
      this.data.itemEventModel?.itemDateEventType == 148 && this.data.itemEventModel?.hasEventTimeEntered
      ? (eventTimeZone ?? TimeZoneEnum.EST) : TimeZoneEnum.EST
    )
  
  }else{
    if(this.data.itemEventModel?.itemDateEventType == 148 && this.data.itemEventModel?.hasEventTimeEntered){
        eventEndTime = this.timezoneUtil.convertFromESTToSelectedTimezone(
      eventEndTime,
      eventTimeZone ?? TimeZoneEnum.EST)}
  }

  const parsedEnd = this.parseUtcIsoToLocalDateTime(eventEndTime, 'end');
  const date = parsedEnd.date; // yyyy-mm-dd
  const time = parsedEnd.time; // HH:mm

  if (this.data.itemEventModel?.hasEventTimeEntered) {
    this.endTimePatch = time;
  }

  this.endDatePatch = date;
  if(this.isDonated){
    this.endAPM = this.endAPMPatch;
    this.startAPM = this.startAPMPatch;
  }

}
    const customFormId = this.setCustomFormTypeValueFromIds();
      const isUnlimited = this.data.priceModel.isUnlimitedParticipation ?? false;
      const formValues = {
        listingTypeId: this.data.itemListingType,
        itemDetails: {
          name: this.data.itemDetails.name,
          typeId: this.data.itemDetails.typeId,
          statusId: this.data.itemDetails.statusId,
          description: this.data.itemDetails.description,
          locationName: this.data.location?.locationName,
          address: this.data.location?.address,
          itemId: this.data.itemDetails.itemId,
          longitude:
            this.campaignType === this.campaignStatus['Volunteer Activity']
              ? null
              : this.data.location?.longitude,
          latitude:
            this.campaignType === this.campaignStatus['Volunteer Activity']
              ? null
              : this.data.location?.latitude,
          itemCustomMessage:this.data.itemDetails?.itemCustomMessage ?? null,

        },
        visilityForm: {
          isPosted: this.data.itemDetails.isPosted,
        },
        price: {
          price: this.data.priceModel.price,
          customMinPrice: this.data.priceModel.customMinPrice,
          customMaxPrice: this.data.priceModel.customMaxPrice,
          quantity: isUnlimited ? null : this.data.priceModel.quantity,
          remainingQuantity: isUnlimited ? null : (this.data.priceModel.remainingQuantity ?? this.data.priceModel.quantity),
          customItemFormLink: this.data.priceModel.customItemFormLink,
          onlinePayment: this.data.priceModel.isAcceptPaymentOnline ? true : false,
          hasVolunteerShifts: this.data.itemEventModel?.hasShifts ?? false,
          isUnlimitedParticipation: isUnlimited,
        },
        participationForm:{
          customFormType: customFormId,
          formType: customFormId ? this.data.priceModel.formType : ParticipantFormTypeEnum['Standard Form'],
        },
        donation: {
          donatedBy: this.data.donation?.donatedBy,
          dedicatedTo: this.data.donation?.dedicatedTo,
          qrPlaque: this.data.donation?.qrPlaque
            ? +this.data.donation?.qrPlaque
            : null,
        },
        itemDates: {
          eventType: this.data.itemEventModel?.itemDateEventType,
          startTime: this.startTimePatch,
          endTime: this.endTimePatch,
          eventStartDate: this.startDatePatch,
          eventEndDate: this.endDatePatch,
          timeZone: this.data.itemEventModel?.itemEventTimeZone ?? null,
        },
      };
      if (this.data.donation?.qrPlaque) {
        this.communityPlaquesData = {
          ...this.communityPlaquesData,
          ...{
            [+this.data.donation?.qrPlaque]:
              this.data.donation?.qrPlaqueName ?? '',
          },
        };
      }
      this.donatedQuantity = this.data.priceModel.quantity - (this.data.priceModel.remainingQuantity ?? 0);

      this.form.patchValue(formValues);
      const msg =(this.data?.itemDetails as any)?.itemCustomMessage ??undefined;
      if(msg){
        this.showCustomizeEmailSection=true;
      }
      if (this.notificationForm) {
        this.notificationForm.patchValue({ itemCustomMessage: msg ?? '' });
        //this.cdr.detectChanges();
      }
      this.setItemFormStatusFields(this.data.itemDetails.statusId);

      if (this.data.priceModel.isUnlimitedParticipation) {
        this.itemPriceForm.get('quantity')?.disable();
        this.itemPriceForm.get('remainingQuantity')?.disable();
      }

      // Set volunteer campaign type if shifts exist
      if (this.data.shifts && this.data.shifts.length > 0) {
        this.setVolunteerCampaignType(true);
        // The shifts are already in VolunteerShiftDto format, so we can pass them directly
        this.loadVolunteerShiftsFromItem(this.data.shifts, this.data.itemEventModel?.itemEventTimeZone ?? TimeZoneEnum.EST);
      }
    }
    
    else {
      if (this.listingTypeId === ItemListingTypeEnum.Multiple) {
        this.form.patchValue({
          itemDetails: {
            statusId: (this.isStatusIdDonated || this.isDonated) ? ITEM_STATUS_TYPE.Donated : ITEM_STATUS_TYPE.Available,
          },
          visilityForm: {
            isPosted: this.isArchived ? POST_ITEM_TYPE.Private : POST_ITEM_TYPE.Public,
          },
          price: {
            isUnlimitedParticipation: false,
          },
        });
      } else if (this.listingTypeId === ItemListingTypeEnum.Custom) {
        this.form.patchValue({
          itemDetails: {
            name: 'General Supporter',
            statusId: (this.isStatusIdDonated || this.isDonated) ? ITEM_STATUS_TYPE.Donated : ITEM_STATUS_TYPE.Available,
            typeId: ITEM_TYPE_ENUM['Monetary Gift'],
          },
          price: {
            onlinePayment: true,
            isUnlimitedParticipation: false,
          },
          visilityForm: {
            isPosted: this.isArchived ? POST_ITEM_TYPE.Private : POST_ITEM_TYPE.Public,
          },
        });

        this.form.get('typeId')?.disable();
      } else if (this.listingTypeId === ItemListingTypeEnum.Single) {
        this.form.patchValue({
          itemDetails: {
            statusId: (this.isStatusIdDonated || this.isDonated) ? ITEM_STATUS_TYPE.Donated : ITEM_STATUS_TYPE.Available,
          },
          visilityForm: {
            isPosted: this.isArchived ? POST_ITEM_TYPE.Private : POST_ITEM_TYPE.Public,
          },
          price: {
            isUnlimitedParticipation: false,
          },
        });
      } 
      
      // For new items, set remainingQuantity to match quantity when quantity changes
      this.itemPriceForm.get('quantity')?.valueChanges.subscribe((quantity) => {
        if (quantity && !this.isEditItem) {
          this.itemPriceForm.get('remainingQuantity')?.setValue(quantity, { emitEvent: false });
        }
      });
    }
    this.cdr.detectChanges();
  }



  private disableControlsWithValue() {
    const controlsToCheck = [
      { formGroup: this.itemDetailForm, keys: ['typeId'] },
      { formGroup: this.itemDonationForm, keys: ['qrPlaque'] },
    ];
    controlsToCheck.forEach(({ formGroup, keys }) => {
      keys.forEach((key) => {
        const control = formGroup.get(key);
        if (control?.value) {
          control.disable();
        }
      });
    });
  }

  private setItemFormStatusFields(value: number) {
    this.isDonationSelected = value === ITEM_STATUS_TYPE.Donated;

    if (value === ITEM_STATUS_TYPE.Donated) {
      this.clearAllValidators(this.itemPriceForm);
      this.availableStepsLocal = [
        ...this.availableSteps.filter((step) => step !== Step.PRICING),
      ];
      if (this.listingTypeId === ItemListingTypeEnum.Multiple) {
        this.availableStepsLocal = [
          ...this.availableStepsLocal.filter(
            (step) => step !== Step.DONATION && step !== Step.PRICING
          ),
        ];
      }
    } else {
      // if (
      //   this.listingTypeId !== ItemListingTypeEnum.Custom &&
      //   this.itemPriceForm.get('participationMethod')?.value ===
      //     ParticipationMethodEnum.StripePayment
      // ) 
      // {
      //   this.itemPriceForm
      //     .get('price')
      //     ?.setValidators([Validators.required, Validators.min(1)]);
      //   this.updateAllValuesAndValidity(this.itemPriceForm);
      // }

      this.availableStepsLocal = [
        ...this.availableSteps.filter((step) => step !== Step.DONATION),
      ];
    }

    this.emitAvailableSteps.emit(this.availableStepsLocal);
  }

  clearAllValidators(formGroup: FormGroup | FormArray): void {
    formGroup.clearValidators();
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup || control instanceof FormArray) {
        this.clearAllValidators(control);
      } else {
        control?.clearValidators();
      }
      control?.updateValueAndValidity();
    });
  }

  updateAllValuesAndValidity(formGroup: FormGroup | FormArray): void {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup || control instanceof FormArray) {
        this.updateAllValuesAndValidity(control);
      }
      control?.updateValueAndValidity();
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    const target = event.target as Window;
    this.updateViewMode(target.innerWidth);
  }

  updateViewMode(width: number): void {
    this.isLaptopView = width > 1359;
  }

  private getCommunitPlaques(id: number): void {
    this.communityService
      .getCommunityPlaques(id)
      .pipe(takeUntil(this.ngUnSubscribe$))
      .subscribe({
        next: (data) => {
          this.communityPlaquesData = { ...this.communityPlaquesData, ...data };
          if (this.preSelectedPlaque?.length) {
            const plaqueIdsToRemove = new Set(
              this.preSelectedPlaque
                .filter((p) => p.itemId !== this.data?.id) // Remove only if itemId is different
                .map((p) => p.plaqueId) // Extract plaqueIds to remove
            );

            const filteredData: ICommunityPlaque = Object.keys(
              this.communityPlaquesData
            )
              .map(Number) // Convert object keys to numbers
              .filter((key) => !plaqueIdsToRemove.has(key)) // Exclude plaques marked for removal
              .reduce((acc, key) => {
                acc[key] = this.communityPlaquesData[key];
                return acc;
              }, {} as ICommunityPlaque);

            this.communityPlaquesData = { ...filteredData };
          }
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error fetching data', error);
        },
      });
  }

  inItForm() {
      this.notificationForm = this.fb.group({
          itemCustomMessage: ['']
      });
      let dateValue =null;
    if (this.typeCampaign() === CampaignTypeEnumm['Volunteer Activity']) {
        dateValue=DateLevelEnum['Single Day Event']
      } 
    this.form = this.fb.group({
      itemDetails: this.fb.group({
        name: ['', [Validators.required, noWhitespaceValidator()]],
        typeId: ['',[Validators.required]],
        statusId: ['', [Validators.required]],
        description: [''],
        locationName: [''],
        address: [''],
        longitude: [null, [Validators.min(-180), Validators.max(180)]],
        latitude: [null, [Validators.min(-90), Validators.max(90)]],
      }),
      // location: this.fb.group({
      //   locationName: [''],
      //   address: [''],
      //   longitude: [null, [Validators.min(-180), Validators.max(180)]],
      //   latitude: [null, [Validators.min(-90), Validators.max(90)]],
      // }),
      price: this.fb.group({
        price: [null],
        quantity: [0],
        remainingQuantity: [0],
        participationMethod: [null],
        customItemFormLink: [null],
        customMinPrice: [null],
        customMaxPrice: [null],
        onlinePayment:[false],
        hasVolunteerShifts:[null],
        isUnlimitedParticipation: [false]
      }),
      donation: this.fb.group({
        donatedBy: [''],
        dedicatedTo: [''],
        qrPlaque: [null],
      }),
      itemDates: this.fb.group({
        eventType: [dateValue],
        startTime: [null, [timePatternValidator()]],
        endTime: [null, [timePatternValidator()]],
        eventStartDate: [null],
        eventEndDate: [null],
        timeZone: [null],
      }),
      participationForm: this.fb.group({
        formType: [null,[Validators.required]],
        customFormType: [null],
      }),
      visilityForm: this.fb.group({
        isPosted: [this.isArchived ? 'private' : 'public', [Validators.required]],
      })
    });
  }

  get itemDetailForm() {
    return this.form.get('itemDetails') as FormGroup;
  }
  get itemParticipationForm(){
    return this.form.get('participationForm') as FormGroup;
  }

  // get itemLocationForm() {
  //   return this.form.get('location') as FormGroup;
  // }
  get itemVisiblityForm(){
    return this.form.get('visilityForm') as FormGroup;
  }
  get itemPriceForm() {
    return this.form.get('price') as FormGroup;
  }

  get itemDonationForm() {
    return this.form.get('donation') as FormGroup;
  }

  get itemDatesForm() {
    return this.form.get('itemDates') as FormGroup;
  }
  uploadedFiles(files: FilesModel): void {
    this.uploadedMedia = files;
    const hasFiles =
      (files.galleryFiles?.length ?? 0) > 0 || (files.documentFiles?.length ?? 0) > 0;
    this.emitFileStatus.emit(hasFiles);
  }

  checkFormStatus(): void {
    this.trackFormStatus(this.itemDetailForm, Step.BASIC_INFORMATION);
    // this.trackFormStatus(this.itemLocationForm, Step.LOCATION);
    this.trackFormStatus(this.itemPriceForm, Step.PRICING);
    this.trackFormStatus(this.itemDonationForm, Step.DONATION);
    this.trackFormStatus(this.itemDatesForm, Step.DATES);
    this.trackFormStatus(this.itemParticipationForm,Step.PARTICIPATION);
    this.trackFormStatus(this.itemPriceForm,Step.DETAILS);
  }

  trackFormStatus(formGroup: FormGroup, step: Step): void {
    formGroup.statusChanges.subscribe((status: string) => {
      let isValid = false;

      if (step === Step.LOCATION) {
        const hasValue = Object.values(formGroup.controls).some(
          (control) => control.value !== null && control.value !== ''
        );
        isValid = formGroup.valid && hasValue;
      } else if (step === Step.DATES) {
        isValid = formGroup.get('eventType')?.value;
      }
      else if(step===Step.DETAILS){
        const value = formGroup.get('hasVolunteerShifts')?.value;
        if(value){
          
          isValid= this.volunteerShiftsData.length>0;
        }
        else if(!value){
          isValid = formGroup.get('quantity')?.value || formGroup.get('remaningQuantity')?.value
        }
        
        
      }
     
      
      else {
        isValid = formGroup.valid;
      }

      this.emitFormValidity.emit({ step, isValid });
    });
  }

  handleSubmit() {
    if(this.isTypeVoulunteer && this.listingTypeId===this.itemListingTypeEnum.Single){
      const priceGroup = this.form.get('price') as FormGroup;

        if (priceGroup) {
          Object.keys(priceGroup.controls).forEach(controlName => {
            const control = priceGroup.get(controlName);
            control?.clearValidators();
            control?.setErrors(null);
          });

          priceGroup.updateValueAndValidity();
          this.form.updateValueAndValidity(); 
        }
    }
   if(this.getVolunteerChecks()){
    return;
   }
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(key => {
        const control = this.form.controls[key];
        
        // Check if the control has errors
        if (control.errors) {
          console.log(`Error in control ${key}:`, control.errors);
        }
    });
    
      this.form.markAllAsTouched();
      this.emitSaveClick.emit(false);
      return;
    }
    this.emitValue();
  }
  getVolunteerChecks(){
     if(this.isVolunteerCampaign && this.listingTypeId===this.itemListingTypeEnum.Multiple && this.volunteerShiftsData.length<=0 && this.itemPriceForm.get('hasVolunteerShifts')?.value && !this.isDonated){
      this.form.markAllAsTouched();
      this.showShiftsError=true;
      this.emitSaveClick.emit(false);
      return true;
    }
    return false;
  }

  emitValue() { 
    const emitObj = {} as IBuildItems;
    const selectedPlaque = {} as ISelectedPlaque;
    const itemForm = this.form.get('itemDates') as FormGroup;
    if (itemForm.get('eventType')?.value) {
      if (itemForm.get('eventType')?.value === 149) {
        this.isStartDate = this.combineDateAndTime(
          itemForm.get('eventStartDate')?.value
        );
        this.isEndDate = this.combineDateAndTime(
          itemForm.get('eventEndDate')?.value,
          '2359'
        );
      } else {
        if (
          itemForm.get('eventStartDate')?.value &&
          itemForm.get('endTime')?.value &&
          itemForm.get('startTime')?.value
        ) {
          this.isStartDate = this.combineDateAndTime(
            itemForm.get('eventStartDate')?.value,
            itemForm.get('startTime')?.value,
            this.startAPM
          );
          this.isEndDate = this.combineDateAndTime(
            itemForm.get('eventStartDate')?.value,
            itemForm.get('endTime')?.value,
            this.endAPM
          );
        } else if (
          itemForm.get('eventStartDate')?.value &&
          !itemForm.get('endTime')?.value &&
          !itemForm.get('startTime')?.value
        ) {
          this.isStartDate = this.combineDateAndTime(
            itemForm.get('eventStartDate')?.value
          );
          this.isEndDate = null;
        }
      }
      
  var selectedTimeZone = itemForm.get('timeZone')?.value ?? TimeZoneEnum.EST;
  var selectedEventType = itemForm.get('eventType')?.value;
  if (itemForm.get('startTime')?.value && itemForm.get('endTime')?.value) {
      this.hasStartTime = true;
    }
  // Convert isStartDate and isEndDate to the selected timezone before emitting

  this.startDateInTz = this.isStartDate
    ? this.timezoneUtil.convertFromSelectedTimezoneToEST(
        this.isStartDate,
        selectedEventType === 148 && this.hasStartTime ? selectedTimeZone : TimeZoneEnum.EST
      )
    : null;

  this.endDateInTz = this.isEndDate
    ? this.timezoneUtil.convertFromSelectedTimezoneToEST(
        this.isEndDate,
        selectedEventType === 148 && this.hasStartTime ? selectedTimeZone : TimeZoneEnum.EST
      )
    : null;

  // Emit as ISO strings (or however required)
  this.startDateTime.emit(this.startDateInTz ? this.startDateInTz : null);
  this.endDateTime.emit(this.endDateInTz ? this.endDateInTz : null);
    }

    if (
      this.itemDetailForm.get('statusId')?.value === ITEM_STATUS_TYPE.Available
    ) {
      this.itemDonationForm.patchValue({
        donatedBy: '',
        dedicatedTo: '',
        qrPlaque: '',
      });
    } else {
      this.itemPriceForm.patchValue({
        price: null,
        quantity: 0,
        remainingQuantity: 0,
        participationMethod: null,
      });
    }
    const formValue = this.form.getRawValue();
    this.updateFormMasterIdsFromSelection();
    const campaignItem: ICampaignItem = {
      id: this.data?.id,
      isNew: this.data?.isNew ?? true,
      itemListingType: this.listingTypeId ?? this.data?.itemListingType,
      itemDetails: {
        name: formValue.itemDetails.name,
        itemId: this.data?.itemDetails.itemId,
        typeId: formValue.itemDetails.typeId,
        statusId: formValue.itemDetails.statusId,
        description: formValue.itemDetails.description,
        isPosted: formValue.visilityForm.isPosted,
        gallaryBlob: this.uploadedMedia?.galleryFiles
          ? JSON.stringify(this.uploadedMedia.galleryFiles)
          : '[]',
        documentsBlob: this.uploadedMedia?.documentFiles
          ? JSON.stringify(this.uploadedMedia.documentFiles)
          : '[]',
      },
      location: {
        locationName: formValue.itemDetails?.locationName,
        address: formValue.itemDetails?.address,
        longitude: formValue.itemDetails?.longitude
          ? +formValue.itemDetails.longitude
          : undefined,
        latitude: formValue.itemDetails?.latitude
          ? +formValue.itemDetails.latitude
          : undefined,
      },
      priceModel: {
        price: formValue.price.price,
        quantity: this.isEditItem ? formValue.price.remainingQuantity + this.donatedQuantity : formValue.price.quantity,
        remainingQuantity: formValue.price.remainingQuantity,
        participationMethod: formValue.price.participationMethod,
        customItemFormLink: formValue.price.customItemFormLink,
        customMinPrice: formValue.price.customMinPrice,
        customMaxPrice: formValue.price.customMaxPrice,
        isAcceptPaymentOnline: formValue.price.onlinePayment ? formValue.price.onlinePayment : false,
        formType: this.itemParticipationForm.get('formType')?.value,
        formMasterId: this.formMasterId,
        formTemplateMasterId: this.formMasterTemplateId,
        isUnlimitedParticipation: formValue.price.isUnlimitedParticipation,
        sortOrder: this.data?.priceModel?.sortOrder || 0, // Preserve original sortOrder for existing items, default to 0 if not set
      },
      donation: {
        donatedBy: formValue.donation.donatedBy,
        dedicatedTo: formValue.donation.dedicatedTo,
        qrPlaque: formValue.donation.qrPlaque?.toString(),
      },
      itemEventModel: {
        itemDateEventType: formValue.itemDates.eventType,
        itemEventStartTime: this.startDateInTz,
        itemEventEndTime: this.endDateInTz,
        hasEventTimeEntered: this.hasStartTime,
        itemEventTimeZone: formValue.itemDates.timeZone ?? null,
        hasShifts: formValue.price.hasVolunteerShifts || false,
      },
      formOverviewModel:{
        schema:'',
        title:'',
        description:''
      },
      shifts: this.isVolunteerCampaignType() ? this.convertVolunteerShiftsToDto() : undefined
    };
    if(this.isCloseItem){
      campaignItem.itemDetails.statusId = ITEM_STATUS_TYPE.Donated;
      campaignItem.priceModel.quantity = this.donatedQuantity;
      campaignItem.priceModel.sortOrder = 1;
      campaignItem.isCloseItem = true;
    }
      const customMessage= this.notificationForm?.get('itemCustomMessage')?.value ?? undefined;
      (campaignItem.itemDetails as any).itemCustomMessage = customMessage;

    selectedPlaque.itemId = this.data?.id ?? '';
    if (formValue.donation.qrPlaque?.toString()) {
      selectedPlaque.plaqueId = +formValue.donation.qrPlaque;
      selectedPlaque.plaqueName =
        this.communityPlaquesData[+formValue.donation.qrPlaque];
    }
    emitObj.selectedPlaque = selectedPlaque;
    emitObj.campaignItem = campaignItem;
    this.isFormValid.emit(this.form.valid);
    
    // Check if we should save directly or emit to parent
    if (this.saveDirectly === true) {
      this.saveItemDirectly(campaignItem);
    } else {
      this.emitFormValue.emit(emitObj);
    }
  }

 updateFormMasterIdsFromSelection(): void {
  const selectedIdRaw = this.itemParticipationForm.get('customFormType')?.value;
  const selectedId = selectedIdRaw ? +selectedIdRaw : undefined;

  if (selectedId !== undefined && this.formListingDict) {
    const matchedEntry = this.formListingDict[selectedId];

    if (matchedEntry) {
      if (matchedEntry.isTemplateForm) {
        this.formMasterTemplateId = matchedEntry.id;
        this.formMasterId = null;
      } else {
        this.formMasterId = matchedEntry.id;
        this.formMasterTemplateId = null;
      }
    } else {
      this.formMasterId = null;
      this.formMasterTemplateId = null;
    }
  } else {
    this.formMasterId = null;
    this.formMasterTemplateId = null;
  }
}

setCustomFormTypeValueFromIds() {
  let idToSet: number | null = null;

  if (this.data?.priceModel.formMasterId != null) {
    idToSet = this.data.priceModel.formMasterId;
  } else if (this.data?.priceModel.formTemplateMasterId != null) {
    idToSet = this.data.priceModel.formTemplateMasterId;
  }
  
  if(this.data?.priceModel.formType === ParticipantFormTypeEnum['Standard Form']){
    return null;
  }
  if (idToSet != null && this.formListingDict) {
  const matchingKey = Object.keys(this.formListingDict)
    .find(key => this.formListingDict[+key].id === idToSet);

  if (matchingKey !== undefined) {
    const numericKey = +matchingKey;
    return numericKey;

  } else {
   return null


  }
} else {
  return null;


}
}

  combineDateAndTime(dateStr: string, timeStr?: string, amPm?: string): Date {
    if (!dateStr) {
      throw new Error('Date is required');
    }

    const [month, day, year] = dateStr.split('/').map(Number);

    let hours = 0;
    let minutes = 0;

    if (timeStr && timeStr.trim() !== '') {
      const timeFormatted = timeStr.padStart(4, '0');
      hours = parseInt(timeFormatted.substring(0, 2), 10);
      minutes = parseInt(timeFormatted.substring(2, 4), 10);

      if (amPm === 'AM') {
        if (hours === 12) {
          hours = 0;
        }
      } else if (amPm === 'PM') {
        if (hours !== 12) {
          hours += 12;
        }
      }
    }

    const date = new Date(year, month - 1, day, hours, minutes, 0);
    return date;
  }

  combineShiftDateAndTime(shift: IVolunteerShifts, isStartTime: boolean = true): Date {
    if (!shift.eventDate) {
      throw new Error('Shift date is required');
    }

    const [month, day, year] = shift.eventDate.split('/').map(Number);
    let hours = 0;
    let minutes = 0;

    const timeStr = isStartTime ? shift.startTime : shift.endTime;
    const amPm = isStartTime ? shift.startTimeAPM : shift.endTimeAPM;
    
    if (timeStr && timeStr.trim() !== '') {
      const timeFormatted = timeStr.padStart(4, '0');
      hours = parseInt(timeFormatted.substring(0, 2), 10);
      minutes = parseInt(timeFormatted.substring(2, 4), 10);
      
      // Handle AM/PM conversion
      if (amPm === 'PM' && hours !== 12) {
        hours += 12;
      } else if (amPm === 'AM' && hours === 12) {
        hours = 0;
      }
    }

    const date = new Date(year, month - 1, day, hours, minutes, 0);
    return date;
  }
  toLocalISOString(date: Date | null) {
    if (!date) {
      return;
    }
    const pad = (n: number): string => n.toString().padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  ngOnDestroy(): void {
    this.ngUnSubscribe$.next();
    this.ngUnSubscribe$.complete();
  }

  removeShiftError(val:boolean){
    if(this.drawerSize){
      this.showShiftsError=false;
    }
    this.removeErrorShift.emit(val);
  }
  // Volunteer shift methods
  setVolunteerShifts(shifts: IVolunteerShifts[]): void {
    if(shifts.length<=0){
      this.isShiftListAvailable.emit(true);
    }
    else{
      this.isShiftListAvailable.emit(false);
    }
    if(this.drawerSize && shifts.length>0){
      this.showShiftsError=false;
    }
    this.volunteerShiftsData = shifts;
    if(this.itemPriceForm.get('hasVolunteerShifts')?.value && this.volunteerShiftsData.length>0){
      const step = Step.DETAILS;
      const isValid = true;
      this.emitFormValidity.emit({step,isValid})
    }
   else if(this.itemPriceForm.get('hasVolunteerShifts')?.value && this.volunteerShiftsData.length<=0){
      const step = Step.DETAILS;
      const isValid = false;
      this.emitFormValidity.emit({step,isValid})
    }
  }
  getFormStatus(){
    if(this.form.invalid){
      return true;
    }
    return false;
  }
  getVolunteerShifts(): IVolunteerShifts[] {
    return this.volunteerShiftsData;
  }

  convertVolunteerShiftsToDto(): VolunteerShiftDto[] {
    return this.volunteerShiftsData.map(shift => {
      // Apply the same hasShifts logic as hasEventTimeEntered
      const itemForm = this.form.get('itemDates') as FormGroup;
      const priceForm = this.form.get('price') as FormGroup;
      const selectedTimeZone = itemForm.get('timeZone')?.value ?? TimeZoneEnum.EST;
      const hasShifts = priceForm.get('hasVolunteerShifts')?.value;
      const hasShiftTime = shift.startTime && shift.endTime;
      
      // Combine shift date and times
      const startDateTime = this.combineShiftDateAndTime(shift, true);
      const endDateTime = this.combineShiftDateAndTime(shift, false);
      
      // Apply timezone conversion using the same logic as item dates
      const convertedStartDateTime = startDateTime
        ? this.timezoneUtil.convertFromSelectedTimezoneToEST(
            startDateTime,
            hasShifts && hasShiftTime ? selectedTimeZone : TimeZoneEnum.EST
          )
        : null;
      
      const convertedEndDateTime = endDateTime
        ? this.timezoneUtil.convertFromSelectedTimezoneToEST(
            endDateTime,
            hasShifts && hasShiftTime ? selectedTimeZone : TimeZoneEnum.EST
          )
        : null;

      return {
        id: shift.id,
        title: shift.shiftTitle || '',
        eventStartDateTime: convertedStartDateTime || startDateTime.toISOString(),
        eventEndDateTime: convertedEndDateTime || endDateTime.toISOString(),
        quantity: shift.quantity || 0,
        donationCompletedCount: shift.donationCompletedCount || 0,
        startTimeAPM: shift.startTimeAPM || 'AM',
        endTimeAPM: shift.endTimeAPM || 'AM'
      };
    });
  }

  convertVolunteerShiftsToInterface(): IVolunteerShift[] {
    return this.volunteerShiftsData.map(shift => {
      return {
        id: shift.id,
        shiftTitle: shift.shiftTitle || '',
        eventDate: shift.eventDate || '',
        startTime: shift.startTime || '',
        endTime: shift.endTime || '',
        quantity: shift.quantity || 0,
        donationCompletedCount: shift.donationCompletedCount || 0,
        startTimeAPM: shift.startTimeAPM || 'AM',
        endTimeAPM: shift.endTimeAPM || 'AM'
      };
    });
  }

  loadVolunteerShiftsFromItem(shifts: VolunteerShiftDto[], selectedTimeZone: number): void {
    if (shifts && shifts.length > 0) {
      this.volunteerShiftsData = shifts.map((shift: VolunteerShiftDto) => 
        this.convertFromVolunteerShiftDto(shift, selectedTimeZone)
      );
    } else {
      this.volunteerShiftsData = [];
    }
  }

  convertFromVolunteerShiftDto(shiftDto: VolunteerShiftDto, selectedTimeZone: number): IVolunteerShifts {
    const eventTimeZone = selectedTimeZone;
    let convertedStartDateTime = shiftDto.eventStartDateTime;
    let convertedEndDateTime = shiftDto.eventEndDateTime;
    
    // Apply timezone conversion for shifts
    if (typeof convertedStartDateTime === 'string' && convertedStartDateTime.endsWith('Z')) {
      convertedStartDateTime = this.timezoneUtil.convertFromUTCToSelectedTimezone(
        convertedStartDateTime,
        eventTimeZone
      );
    } else {
        convertedStartDateTime = this.timezoneUtil.convertFromESTToSelectedTimezone(
          convertedStartDateTime,
          eventTimeZone
        );
    }
    
    if (typeof convertedEndDateTime === 'string' && convertedEndDateTime.endsWith('Z')) {
      convertedEndDateTime = this.timezoneUtil.convertFromUTCToSelectedTimezone(
        convertedEndDateTime,
        eventTimeZone
      );
    } else {
        convertedEndDateTime = this.timezoneUtil.convertFromESTToSelectedTimezone(
          convertedEndDateTime,
          eventTimeZone
        );
    }
    
    // Parse the converted dates and get the correct AM/PM values
    const startDate = this.parseUtcIsoToLocalDateTime(convertedStartDateTime, 'start',true);
    const endDate = this.parseUtcIsoToLocalDateTime(convertedEndDateTime, 'end',true);
    
    return {
      id: shiftDto.id,
      shiftTitle: shiftDto.title || '',
      eventDate: startDate.date,
      startTime: startDate.time,
      endTime: endDate.time,
      quantity: shiftDto.quantity || 0,
      donationCompletedCount: shiftDto.donationCompletedCount || 0,
      startTimeAPM: startDate.amPm,
      endTimeAPM: endDate.amPm
    };
  }

  isVolunteerCampaignType(): boolean {
    return this.isVolunteerCampaign;
  }

  setVolunteerCampaignType(isVolunteer: boolean): void {
    this.isVolunteerCampaign = isVolunteer;
  }

  private saveItemDirectly(campaignItem: ICampaignItem): void {
    const fromGallery = this.router.url.includes('/gallery')
    this.spinnerService.showSpinner();
    
    const itemCreateDto = this.mapToIItemCreateDto(campaignItem);
    
    this.itemService.saveItem(itemCreateDto).subscribe({
      next: (response) => {
        this.campaignSignalService.triggerRefresh();
        this.closeDrawer();
        setTimeout(() => {
          this.spinnerService.hideSpinner();
          if (this.campaignId) {
            this.router.navigate([`/campaign/${this.campaignId}/overview`]);
          } else if(fromGallery && this.isFromCommunityStories) {
            this.router.navigate([`/community/${this.communityId}/stories/gallery`]);
          }
          else if(this.isFromCommunityStories){
            this.router.navigate([`/community/${this.communityId}/stories`]);
          }
        }, 1000); // 1 second delay to allow grid to refresh
      },
      error: (error) => {
        this.spinnerService.hideSpinner();
        this.toastrService.error({ message: 'Failed to save item. Please try again.' });
        console.error('Error saving item:', error);
      }
    });
  }
  
setQuantityToZero(isLocal: boolean = true): void {
    if (this.volunteerShiftsData) {
  this.volunteerShiftsData = this.volunteerShiftsData.map(item => ({
    ...item,
    quantity: 0
  }));
}
  const priceGroup = this.form.get('price') as FormGroup;
  if (!priceGroup) return;
  const remainingControl = priceGroup.get('remainingQuantity');
  if (remainingControl) {
    remainingControl.clearValidators();
    remainingControl.setErrors(null);
    remainingControl.setValue(0);
    remainingControl.updateValueAndValidity();
  }
  priceGroup.updateValueAndValidity();
  this.form.updateValueAndValidity();
  this.saveDirectly = !isLocal;
  this.isCloseItem = true;
  if (isLocal) {
    const itemDetailsGroup = this.form.get('itemDetails') as FormGroup;
    if (itemDetailsGroup) {
      const statusIdControl = itemDetailsGroup.get('statusId');
      if (statusIdControl) {
        statusIdControl.setValue(ITEM_STATUS_TYPE.Donated);
        statusIdControl.updateValueAndValidity();
      }
    }
    this.emitValue();
  } else {
    this.handleSubmit();
  }
}


  private mapToIItemCreateDto(campaignItem: ICampaignItem): IItemCreateDto {
    return {
      id: campaignItem.id ? +campaignItem.id : 0,
      name: campaignItem.itemDetails.name,
      description: campaignItem.itemDetails.description,
      originalDescription: this.originalDescription,
      typeId: campaignItem.itemDetails.typeId,
      itemLatitude: campaignItem.location?.latitude,
      itemLongitude: campaignItem.location?.longitude,
      address: campaignItem.location?.address,
      locationName: campaignItem.location?.locationName,
      price: campaignItem.priceModel.price,
      customMinPrice: campaignItem.priceModel.customMinPrice,
      customMaxPrice: campaignItem.priceModel.customMaxPrice,
      quantity: campaignItem.priceModel.quantity ?? 0,
      itemListingType: campaignItem.itemListingType,
      statusId: campaignItem.itemDetails.statusId,
      isPosted: campaignItem.itemDetails.isPosted === 'public',
      communityId: this.communitySignalService.getCommunity()?.id ?? 0,
      communityName: this.communitySignalService.getCommunity()?.displayName ?? '',
      campaignId: this.campaignId ? Number(this.campaignId) : null,
      blobUrls: campaignItem.itemDetails.gallaryBlob,
      documentBlobUrls: campaignItem.itemDetails.documentsBlob,
      dedicatedTo: campaignItem.donation?.dedicatedTo,
      donatedBy: campaignItem.donation?.donatedBy,
      plaqueId: campaignItem.donation?.qrPlaque,
      participationMethod: campaignItem.priceModel.participationMethod,
      customItemFormLink: campaignItem.priceModel.customItemFormLink,
      ItemDateEventType: campaignItem.itemEventModel?.itemDateEventType,
      ItemEventStartTime: this.startDateInTz ?? undefined,
      ItemEventEndTime: this.endDateInTz ?? undefined,
      hasEventTimeEntered: this.hasStartTime,
      isAcceptPaymentOnline: campaignItem.priceModel.isAcceptPaymentOnline || false,
      formTypeId: campaignItem.priceModel.formType ?? null,
      formMasterId: campaignItem.priceModel.formMasterId || null,
      itemEventTimeZone: campaignItem.itemEventModel?.itemEventTimeZone || null,
      shifts: campaignItem.shifts,
      hasShifts: campaignItem.itemEventModel?.hasShifts || false,
      isUnlimitedParticipation: campaignItem.priceModel.isUnlimitedParticipation,
      sortOrder: campaignItem.priceModel.sortOrder,
      itemCustomMessage:campaignItem.itemDetails.itemCustomMessage,
    };
  }

  private closeDrawer(): void {
    this.closeDrawerEvent.emit();
  }

  deleteCustomEmail(){
     this.showCustomizeEmailSection = false;
     if (this.notificationForm) {
        this.notificationForm.get('itemCustomMessage')?.setValue('');
        this.notificationForm.get('itemCustomMessage')?.markAsPristine();
        this.notificationForm.get('itemCustomMessage')?.markAsUntouched();
      }
  }
}
